import { useMemo, type ReactElement } from 'react';

export interface SparklineChartProps {
  data: readonly number[];
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
}

export function SparklineChart({
  data,
  color = 'var(--ant-color-primary)',
  width = 80,
  height = 24,
  strokeWidth = 1.5,
}: SparklineChartProps): ReactElement {
  const path = useMemo(() => {
    if (data.length < 2) {
      return '';
    }

    const max = Math.max(...data);
    const min = Math.min(...data);
    const range = max - min || 1;
    const step = width / (data.length - 1);

    return data
      .map((value, index) => {
        const x = index * step;
        const y = height - ((value - min) / range) * (height - 4) - 2;
        return `${index === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`;
      })
      .join(' ');
  }, [data, height, width]);

  return (
    <svg width={width} height={height} style={{ overflow: 'visible' }}>
      <path
        d={path}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
